import { Box, Checkbox } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ScenarioHeaderLabel as HeaderLabel } from "./scenario-header-label"
import { If } from "lib/@components/switch"

export function ScenarioTableHeader() {
    const { selectedIds, onSelectAll, pageItems, canManageOptimiser } = useBoundContext()
    const allSelected = pageItems?.length > 0 && pageItems.every(isSelected)
    const someSelected = !allSelected && pageItems?.some(isSelected)

    return (
        <ListItemBox
            sx={{
                bgcolor: "background.neutral",
                borderRadius: 1,
                px: 3,
                py: 1.5,
                gap: 3,
            }}
        >
            <If value={canManageOptimiser}>
                <Checkbox
                    size="small"
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={onSelectAll}
                    sx={{ p: 0, mr: -1 }}
                />
            </If>
            <Box sx={{ flex: 3, minWidth: 200 }}>
                <HeaderLabel>Name</HeaderLabel>
            </Box>
            <Box sx={{ flex: 2 }}>
                <HeaderLabel>Regime</HeaderLabel>
            </Box>
            <Box sx={{ width: 120 }}>
                <HeaderLabel>Rate Card</HeaderLabel>
            </Box>
            <Box sx={{ width: 70, textAlign: "right" }}>
                <HeaderLabel align="right">Variants</HeaderLabel>
            </Box>
            <Box sx={{ width: 140, textAlign: "right" }}>
                <HeaderLabel align="right">Annual Cost</HeaderLabel>
            </Box>
            <Box sx={{ width: 120 }}>
                <HeaderLabel>Created</HeaderLabel>
            </Box>
            <Box sx={{ width: 40 }} />
        </ListItemBox>
    )

    function isSelected(i) {
        return selectedIds?.has(i.id)
    }
}
